

import './App.css';
import PauseButton from './PauseButton';

import Pomodoro from './Pomodoro';



function App() {
  return (
    <>
   <div className = "App">

     
     <Pomodoro/>
     
     
  
   </div>
   
 
   </>
  );
}

export default App;
